<template>
  <ContentLoader v-slot :loading="item == null">
    <Hero :image="item.image">
      <h1>
        {{ item.name }}
        <!--
        <b-button variant="link" class="p-0" @click="toggleFavourite">
          <Icon :icon="isFavourite ? 'heart-fill' : 'heart'" />
        </b-button>
        -->
      </h1>
      <div class="mb-3">
        <strong>{{ item.albumCount }}</strong> 专辑 •
        <strong>{{ item.trackCount }}</strong> 歌曲
        <!--
        <div v-if="item.genres.length > 0">
          <span v-for="({ name: genre }, index) in item.genres" :key="genre">
            <span v-if="index > 0">•</span>
            <router-link :to="{name: 'genre', params: { id: genre }}">
              {{ genre }}
            </router-link>
          </span>
        </div>
        -->
      </div>
      <OverflowFade v-if="item.description || item.lastFmUrl || item.musicBrainzUrl" class="mb-3">
        {{ item.description }}
        <ExternalLink v-if="item.lastFmUrl" :href="item.lastFmUrl">
          Last.fm <Icon icon="link" />
        </ExternalLink>.
        <ExternalLink v-if="item.musicBrainzUrl" :href="item.musicBrainzUrl">
          MusicBrainz <Icon icon="link" />
        </ExternalLink>
      </OverflowFade>
      <div class="text-nowrap">
        <b-button variant="secondary" :disabled="item.topTracks.length === 0" class="mr-2" @click="playNow">
          <Icon icon="play" /> 播放
        </b-button>
        <b-button variant="secondary" :disabled="item.topTracks.length === 0" @click="shuffleNow">
          <Icon icon="shuffle" /> 随机播放
        </b-button>
      </div>
    </Hero>

    <template v-if="item.topTracks.length > 0">
      <div class="d-flex justify-content-between mt-5 mb-2">
        <h3 class="my-0">
          Top tracks
        </h3>
        <router-link :to="{name: 'artist-tracks', params: { id }}">
          View all
        </router-link>
      </div>
      <TrackList :tracks="item.topTracks" no-artist />
    </template>

    <template v-if="albums.length > 0">
      <div class="d-flex justify-content-between mt-5 mb-2">
        <h3 class="my-0">
          专辑列表
        </h3>
        <b-button variant="link" class="p-0" @click="toggleAlbumSortOrder">
          <Icon icon="arrow-up-down" />
        </b-button>
      </div>
      <AlbumList :items="albums" />
    </template>

    <template v-if="item.similarArtist.length > 0">
      <h3 class="mt-5">
        相似艺术家
      </h3>
      <ArtistList :items="item.similarArtist" />
    </template>
  </ContentLoader>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import AlbumList from '@/library/album/AlbumList.vue'
  import ArtistList from '@/library/artist/ArtistList.vue'
  import TrackList from '@/library/track/TrackList.vue'
  import { useFavouriteStore } from '@/library/favourite/store'
  import OverflowFade from '@/shared/components/OverflowFade.vue'
  import { Album } from '@/shared/api'
  import { orderBy } from 'lodash-es'
  import { useMainStore } from '@/shared/store'

  export default defineComponent({
    components: {
      AlbumList,
      ArtistList,
      OverflowFade,
      TrackList,
    },
    props: {
      id: { type: String, required: true }
    },
    setup() {
      return {
        mainStore: useMainStore(),
        favouriteStore: useFavouriteStore()
      }
    },
    data() {
      return {
        item: null as any,
      }
    },
    computed: {
      isFavourite(): boolean {
        return !!this.favouriteStore.artists[this.id]
      },
      albums(): Album[] {
        return orderBy(this.item?.albums ?? [], 'year', this.mainStore.artistAlbumSortOrder)
      },
    },
    watch: {
      id: {
        immediate: true,
        async handler(value: string) {
          this.item = null
          this.item = await this.$api.getArtistDetails(value)
        }
      }
    },
    methods: {
      playNow() {
        return this.$store.dispatch('player/playNow', {
          tracks: this.item.topTracks,
        })
      },
      shuffleNow() {
        return this.$store.dispatch('player/shuffleNow', {
          tracks: this.item.topTracks,
        })
      },
      toggleFavourite() {
        return this.favouriteStore.toggle('artist', this.id)
      },
      toggleAlbumSortOrder() {
        this.mainStore.toggleArtistAlbumSortOrder()
      }
    }
  })
</script>
